import * as common from '../apiCommon';
const TILL_MOVEMENT_TYPE = 'till_movement_type';
export function fetchTillMovementTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'till_movement_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}



export async function fetchAllTillMovementTypes(app) {
  const result = await common.queryDocs(app, TILL_MOVEMENT_TYPE, {
    limit: 100,
  });

  return result.data;
}

